import React, { useState, useEffect, useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useToast } from "@chakra-ui/react";
import { fetchUsers, deleteUser, activateUser, deactivateUser, createUser, updateUser, getUserById } from "action/userAction";
import { validateEmail } from "data/mockData";
import { validation } from "utils/commonUtils";

/* ── Icons ── */
const PlusIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16">
    <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
  </svg>
);
const SearchIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16">
    <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
  </svg>
);
const EditIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="15" height="15">
    <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
    <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
  </svg>
);
const TrashIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="15" height="15">
    <polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
    <path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/>
  </svg>
);
const ToggleIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="15" height="15">
    <rect x="1" y="5" width="22" height="14" rx="7" ry="7"/>
    <circle cx="8" cy="12" r="3"/>
  </svg>
);
const ChevronRightIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="12" height="12">
    <polyline points="9 18 15 12 9 6"/>
  </svg>
);
const XIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="14" height="14">
    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
  </svg>
);
const UserPlusIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16">
    <path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/>
    <line x1="19" y1="8" x2="19" y2="14"/><line x1="22" y1="11" x2="16" y2="11"/>
  </svg>
);
const EyeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="15" height="15">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
  </svg>
);
const EyeOffIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="15" height="15">
    <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"/>
    <line x1="1" y1="1" x2="23" y2="23"/>
  </svg>
);
const UserIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="15" height="15">
    <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/>
  </svg>
);
const EditUserIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16">
    <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/>
    <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
  </svg>
);
const MoreVIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16">
    <circle cx="12" cy="5" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="12" cy="19" r="1"/>
  </svg>
);
const MailIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="15" height="15">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);
const LockIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="15" height="15">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
    <path d="M7 11V7a5 5 0 0110 0v4"/>
  </svg>
);

/* ── Helpers ── */
function Avatar({ name }) {
  const initials = (name || "U").split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
  const colors = ["#4F46E5","#0EA5E9","#10B981","#F59E0B","#EF4444","#8B5CF6"];
  const bg = colors[(name || "U").charCodeAt(0) % colors.length];
  return <div className="lms-avatar lms-avatar-sm" style={{ background: bg }}>{initials}</div>;
}

function Badge({ variant, children }) {
  return <span className={`lms-badge lms-badge-${variant}`}>{children}</span>;
}

/* ── Row dropdown menu ── */
function UserRowMenu({ user, onEdit, onToggle, onDelete }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef();
  useEffect(() => {
    if (!open) return;
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, [open]);
  const close = () => setOpen(false);
  const isActive = user.status === "Active";
  return (
    <div className="lms-dropdown-wrapper" ref={ref}>
      <button className="lms-btn lms-btn-ghost lms-btn-sm lms-btn-icon" onClick={() => setOpen((o) => !o)}>
        <MoreVIcon />
      </button>
      {open && (
        <div className="lms-dropdown" style={{ right: 0, minWidth: 180 }}>
          <button className="lms-dropdown-item" onClick={() => { close(); onEdit(user); }}><EditIcon /> {t("Edit User")}</button>
          <button
            className="lms-dropdown-item"
            onClick={() => { close(); onToggle(user); }}
            style={{ color: isActive ? "var(--warning-600)" : "var(--success-600)" }}
          >
            <ToggleIcon /> {isActive ? t("Deactivate") : t("Activate")}
          </button>
          <div className="lms-dropdown-divider" />
          <button className="lms-dropdown-item danger" onClick={() => { close(); onDelete(user); }}><TrashIcon /> {t("Delete User")}</button>
        </div>
      )}
    </div>
  );
}

/* ── Confirm Dialog ── */
function ConfirmDialog({ open, title, message, confirmLabel, confirmVariant = "danger", loading, onConfirm, onCancel }) {
  const { t } = useTranslation();
  if (!open) return null;
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,0.5)", backdropFilter: "blur(4px)", zIndex: 90, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div style={{ background: "#fff", borderRadius: 20, boxShadow: "0 24px 48px -12px rgba(15,23,42,0.18)", width: "100%", maxWidth: 440, overflow: "hidden" }} onClick={(e) => e.stopPropagation()}>
        <div style={{ padding: "20px 24px 16px", borderBottom: "1px solid var(--border-subtle)" }}>
          <div className="t-h2">{title}</div>
        </div>
        <div style={{ padding: "16px 24px" }}>
          <div className="t-body">{message}</div>
        </div>
        <div style={{ padding: "14px 24px", borderTop: "1px solid var(--border-subtle)", display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <button className="lms-btn lms-btn-secondary" onClick={onCancel} disabled={loading}>{t("Cancel")}</button>
          <button
            className={`lms-btn lms-btn-${confirmVariant === "danger" ? "danger" : "primary"}`}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? <span className="lms-spinner" style={{ width: 14, height: 14 }} /> : null}
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ── Password Field ── */
function PasswordField({ label, name, value, onChange, placeholder, show, onToggle, error }) {
  return (
    <div className={`lms-form-group ${error ? "has-error" : ""}`}>
      <label className="lms-label">
        {label} <span style={{ color: "var(--danger-500)" }}>*</span>
      </label>
      <div style={{ position: "relative" }}>
        <span style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "var(--text-muted)", display: "flex", pointerEvents: "none" }}>
          <LockIcon />
        </span>
        <input
          className="lms-input"
          name={name}
          type={show ? "text" : "password"}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          style={{ paddingLeft: 38, paddingRight: 44 }}
        />
        <button
          type="button"
          onClick={onToggle}
          style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "var(--text-muted)", display: "flex", alignItems: "center", padding: 0 }}
        >
          {show ? <EyeOffIcon /> : <EyeIcon />}
        </button>
      </div>
      {error && <div className="lms-error-msg">{error}</div>}
    </div>
  );
}

/* ── Create User Modal ── */
function CreateUserModal({ open, onClose, onCreated, toast }) {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({ name: "", email: "", password: "", confirmPassword: "" });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  useEffect(() => {
    if (open) {
      setFormData({ name: "", email: "", password: "", confirmPassword: "" });
      setErrors({});
      setShowPassword(false);
      setShowConfirmPassword(false);
    }
  }, [open]);

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    const e = {};
    if (!formData.name.trim()) e.name = t("Name is required");
    else if (formData.name.trim().length < 2) e.name = t("Name must be at least 2 characters");
    if (!formData.email.trim()) e.email = t("Email is required");
    else if (!validateEmail(formData.email)) e.email = t("Please enter a valid email address");
    if (!formData.password) e.password = t("Password is required");
    else if (formData.password.length < 6) e.password = t("Password must be at least 6 characters");
    if (!formData.confirmPassword) e.confirmPassword = t("Please confirm your password");
    else if (formData.password !== formData.confirmPassword) e.confirmPassword = t("Passwords do not match");
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = async (ev) => {
    ev.preventDefault();
    if (!validate()) return;
    try {
      setLoading(true);
      const result = await createUser({ name: formData.name.trim(), email: formData.email.trim(), password: formData.password, position: formData.position, phone: formData.phone, status: "Active" });
      if (!result.success) {
        toast({ title: t("Error"), description: result.message || t("Failed to create user"), status: "error", duration: 5000, isClosable: true });
        return;
      }
      toast({ title: t("User Created"), description: t("User berhasil dibuat."), status: "success", duration: 3000, isClosable: true });
      onCreated();
    } catch {
      toast({ title: t("Error"), description: t("Failed to create user. Please try again."), status: "error", duration: 5000, isClosable: true });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,0.5)", backdropFilter: "blur(4px)", zIndex: 90, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}
      onClick={onClose}
    >
      <div
        style={{ background: "#fff", borderRadius: 20, boxShadow: "0 24px 48px -12px rgba(15,23,42,0.18)", width: "100%", maxWidth: 560, overflow: "hidden" }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Modal header */}
        <div style={{ padding: "20px 24px", borderBottom: "1px solid var(--border-subtle)", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div style={{ width: 40, height: 40, borderRadius: 12, background: "var(--brand-50)", display: "flex", alignItems: "center", justifyContent: "center", color: "var(--brand-500)", flexShrink: 0 }}>
              <UserPlusIcon />
            </div>
            <div>
              <div className="t-h2">{t("Create New User")}</div>
              <div className="t-small" style={{ color: "var(--text-muted)", marginTop: 2 }}>{t("Tambahkan pengguna baru ke platform")}</div>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            style={{ background: "none", border: "none", cursor: "pointer", color: "var(--text-muted)", display: "flex", alignItems: "center", padding: 6, borderRadius: 8 }}
          >
            <XIcon />
          </button>
        </div>

        {/* Modal body */}
        <form onSubmit={handleSubmit}>
          <div style={{ padding: "20px 24px", display: "flex", flexDirection: "column", gap: 16 }}>

            {/* Full Name */}
            <div className={`lms-form-group ${errors.name ? "has-error" : ""}`}>
              <label className="lms-label">{t("Full Name")} <span style={{ color: "var(--danger-500)" }}>*</span></label>
              <div style={{ position: "relative" }}>
                <span style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "var(--text-muted)", display: "flex", pointerEvents: "none" }}>
                  <UserIcon />
                </span>
                <input
                  className="lms-input"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder={t("Enter full name")}
                  style={{ paddingLeft: 38 }}
                />
              </div>
              {errors.name && <div className="lms-error-msg">{errors.name}</div>}
            </div>

            {/* Email */}
            <div className={`lms-form-group ${errors.email ? "has-error" : ""}`}>
              <label className="lms-label">{t("Email Address")} <span style={{ color: "var(--danger-500)" }}>*</span></label>
              <div style={{ position: "relative" }}>
                <span style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "var(--text-muted)", display: "flex", pointerEvents: "none" }}>
                  <MailIcon />
                </span>
                <input
                  className="lms-input"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder={t("Enter email address")}
                  style={{ paddingLeft: 38 }}
                />
              </div>
              {errors.email && <div className="lms-error-msg">{errors.email}</div>}
            </div>

            <div style={{ borderTop: "1px solid var(--border-subtle)" }} />

            {/* Position & Phone row */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
              <div className="lms-form-group">
                <label className="lms-label">Position <span className="t-small" style={{ color: "var(--text-muted)" }}>({t("opsional")})</span></label>
                <input className="lms-input" name="position" value={formData.position || ""} onChange={handleChange} placeholder={t("Contoh: Developer")} />
              </div>
              <div className="lms-form-group">
                <label className="lms-label">Phone <span className="t-small" style={{ color: "var(--text-muted)" }}>({t("opsional")})</span></label>
                <input className="lms-input" name="phone" value={formData.phone || ""} onChange={handleChange} placeholder="08xxxxxxxxxx" />
              </div>
            </div>

            <div style={{ borderTop: "1px solid var(--border-subtle)" }} />

            {/* Password row */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
              <PasswordField
                label={t("Password")}
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder={t("Min. 6 characters")}
                show={showPassword}
                onToggle={() => setShowPassword(!showPassword)}
                error={errors.password}
              />
              <PasswordField
                label={t("Confirm Password")}
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                placeholder={t("Repeat password")}
                show={showConfirmPassword}
                onToggle={() => setShowConfirmPassword(!showConfirmPassword)}
                error={errors.confirmPassword}
              />
            </div>
          </div>

          {/* Modal footer */}
          <div style={{ padding: "16px 24px", borderTop: "1px solid var(--border-subtle)", display: "flex", justifyContent: "flex-end", gap: 8 }}>
            <button type="button" className="lms-btn lms-btn-secondary" onClick={onClose} disabled={loading}>
              {t("Cancel")}
            </button>
            <button type="submit" className="lms-btn lms-btn-primary" disabled={loading}>
              {loading ? <span className="lms-spinner" style={{ width: 14, height: 14 }} /> : <UserPlusIcon />}
              {loading ? t("Creating...") : t("Create User")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

/* ── Edit User Modal ── */
function EditUserModal({ open, userId, onClose, onUpdated, toast }) {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({ name: "", email: "", password: "", status: "Active" });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [initialStatus, setInitialStatus] = useState("Active");

  useEffect(() => {
    if (!open || !userId) return;
    const load = async () => {
      try {
        setFetchLoading(true);
        setErrors({});
        setShowPassword(false);
        const result = await getUserById(userId);
        if (result.success) {
          let status = "Active";
          if (result.data.is_active !== undefined) status = result.data.is_active ? "Active" : "Non Active";
          else if (result.data.status) status = result.data.status;
          setInitialStatus(status);
          setFormData({ name: result.data.name || result.data.nama || "", email: result.data.email || "", password: "", status, position: result.data.position || "", phone: result.data.phone || "" });
        } else {
          toast({ title: t("Error"), description: result.message || t("Failed to load user data"), status: "error", duration: 5000, isClosable: true });
          onClose();
        }
      } catch {
        toast({ title: t("Error"), description: t("Failed to load user data"), status: "error", duration: 5000, isClosable: true });
        onClose();
      } finally {
        setFetchLoading(false);
      }
    };
    load();
  }, [open, userId]);

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    const e = {};
    if (!formData.name.trim()) e.name = t("Name is required");
    else if (formData.name.trim().length < 2) e.name = t("Name must be at least 2 characters");
    if (!formData.email.trim()) e.email = t("Email is required");
    else if (!validateEmail(formData.email)) e.email = t("Please enter a valid email address");
    const pwValidation = validation.validatePassword(formData.password, false);
    if (!pwValidation.isValid) e.password = pwValidation.error;
    if (!formData.status) e.status = t("Status is required");
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = async (ev) => {
    ev.preventDefault();
    if (!validate()) return;
    try {
      setLoading(true);
      const updateData = { name: formData.name.trim(), email: formData.email.trim(), position: formData.position, phone: formData.phone };
      if (formData.password) updateData.password = formData.password;
      const result = await updateUser(userId, updateData);
      if (!result.success) {
        toast({ title: t("Error"), description: result.message || t("Failed to update user"), status: "error", duration: 5000, isClosable: true });
        return;
      }
      if (formData.status !== initialStatus) {
        const statusResult = formData.status === "Active" ? await activateUser(userId) : await deactivateUser(userId);
        if (!statusResult.success) {
          toast({ title: t("Warning"), description: statusResult.message || t("Data updated but failed to change status"), status: "warning", duration: 5000, isClosable: true });
          return;
        }
      }
      toast({ title: t("User Updated"), description: t("User berhasil diperbarui."), status: "success", duration: 3000, isClosable: true });
      onUpdated();
    } catch {
      toast({ title: t("Error"), description: t("Failed to update user. Please try again."), status: "error", duration: 5000, isClosable: true });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,0.5)", backdropFilter: "blur(4px)", zIndex: 90, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}
      onClick={onClose}
    >
      <div
        style={{ background: "#fff", borderRadius: 20, boxShadow: "0 24px 48px -12px rgba(15,23,42,0.18)", width: "100%", maxWidth: 560, overflow: "hidden" }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{ padding: "20px 24px", borderBottom: "1px solid var(--border-subtle)", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div style={{ width: 40, height: 40, borderRadius: 12, background: "var(--warning-50, #fffbeb)", display: "flex", alignItems: "center", justifyContent: "center", color: "var(--warning-600, #d97706)", flexShrink: 0 }}>
              <EditUserIcon />
            </div>
            <div>
              <div className="t-h2">{t("Edit User")}</div>
              <div className="t-small" style={{ color: "var(--text-muted)", marginTop: 2 }}>{t("Perbarui informasi pengguna")}</div>
            </div>
          </div>
          <button type="button" onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "var(--text-muted)", display: "flex", alignItems: "center", padding: 6, borderRadius: 8 }}>
            <XIcon />
          </button>
        </div>

        {/* Body */}
        {fetchLoading ? (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: 48 }}>
            <div className="lms-spinner" />
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{ padding: "20px 24px", display: "flex", flexDirection: "column", gap: 16 }}>

              {/* Name & Email row */}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                <div className={`lms-form-group ${errors.name ? "has-error" : ""}`}>
                  <label className="lms-label">{t("Full Name")} <span style={{ color: "var(--danger-500)" }}>*</span></label>
                  <input className="lms-input" name="name" value={formData.name} onChange={handleChange} placeholder={t("Enter full name")} />
                  {errors.name && <div className="lms-error-msg">{errors.name}</div>}
                </div>
                <div className={`lms-form-group ${errors.email ? "has-error" : ""}`}>
                  <label className="lms-label">{t("Email Address")} <span style={{ color: "var(--danger-500)" }}>*</span></label>
                  <input className="lms-input" name="email" type="email" value={formData.email} onChange={handleChange} placeholder={t("Enter email address")} />
                  {errors.email && <div className="lms-error-msg">{errors.email}</div>}
                </div>
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                <div className="lms-form-group">
                  <label className="lms-label">Position <span className="t-small" style={{ color: "var(--text-muted)" }}>({t("opsional")})</span></label>
                  <input className="lms-input" name="position" value={formData.position || ""} onChange={handleChange} placeholder={t("Contoh: Developer")} />
                </div>
                <div className="lms-form-group">
                  <label className="lms-label">Phone <span className="t-small" style={{ color: "var(--text-muted)" }}>({t("opsional")})</span></label>
                  <input className="lms-input" name="phone" value={formData.phone || ""} onChange={handleChange} placeholder="08xxxxxxxxxx" />
                </div>
              </div>

              <div style={{ borderTop: "1px solid var(--border-subtle)" }} />

              {/* Status & Password row */}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                <div className={`lms-form-group ${errors.status ? "has-error" : ""}`}>
                  <label className="lms-label">{t("Status")} <span style={{ color: "var(--danger-500)" }}>*</span></label>
                  <select className="lms-select" name="status" value={formData.status} onChange={handleChange} style={{ width: "100%" }}>
                    <option value="Active">Active</option>
                    <option value="Non Active">Non Active</option>
                  </select>
                  {errors.status && <div className="lms-error-msg">{errors.status}</div>}
                </div>
                <div className={`lms-form-group ${errors.password ? "has-error" : ""}`}>
                  <label className="lms-label">{t("New Password (Optional)")} <span className="t-small" style={{ color: "var(--text-muted)" }}></span></label>
                  <div style={{ position: "relative" }}>
                    <input
                      className="lms-input"
                      name="password"
                      type={showPassword ? "text" : "password"}
                      value={formData.password}
                      onChange={handleChange}
                      placeholder={t("Leave blank to keep")}
                      style={{ paddingRight: 44 }}
                    />
                    <button type="button" onClick={() => setShowPassword(!showPassword)}
                      style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "var(--text-muted)", display: "flex", alignItems: "center", padding: 0 }}>
                      {showPassword ? <EyeOffIcon /> : <EyeIcon />}
                    </button>
                  </div>
                  {errors.password && <div className="lms-error-msg">{errors.password}</div>}
                </div>
              </div>

            </div>

            {/* Footer */}
            <div style={{ padding: "16px 24px", borderTop: "1px solid var(--border-subtle)", display: "flex", justifyContent: "flex-end", gap: 8 }}>
              <button type="button" className="lms-btn lms-btn-secondary" onClick={onClose} disabled={loading}>{t("Cancel")}</button>
              <button type="submit" className="lms-btn lms-btn-primary" disabled={loading}>
                {loading ? <span className="lms-spinner" style={{ width: 14, height: 14 }} /> : <EditUserIcon />}
                {loading ? t("Updating...") : t("Update User")}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

/* ── Main Page ── */
function UserManagement() {
  const { t } = useTranslation();
  useEffect(() => { document.title = "User Management | LMS Tenant"; }, []);

  const toast = useToast();

  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [filterNama, setFilterNama] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [toggleOpen, setToggleOpen] = useState(false);
  const [createOpen, setCreateOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [editUserId, setEditUserId] = useState(null);

  const loadUsers = useCallback(async () => {
    try {
      setLoading(true);
      const result = await fetchUsers({ per_page: 100 });
      if (result.success) {
        setUsers(result.data.map((u) => ({
          id: u.id,
          nama: u.name,
          email: u.email,
          position: u.position,
          phone: u.phone,
          status: u.is_active === true || u.is_active === 1 ? "Active" : "Non Active",
          tanggalDibuat: u.created_at,
          is_active: u.is_active,
        })));
      } else {
        toast({ title: t("Error"), description: result.message || t("Failed to load users"), status: "error", duration: 3000, isClosable: true });
      }
    } catch {
      toast({ title: t("Error"), description: t("Failed to load users"), status: "error", duration: 3000, isClosable: true });
    } finally {
      setLoading(false);
    }
  }, [toast]);

  useEffect(() => { loadUsers(); }, [loadUsers]);

  const confirmDelete = async () => {
    if (!selectedUser) return;
    try {
      setSaving(true);
      const result = await deleteUser(selectedUser.id);
      if (result.success) {
        toast({ title: t("User Deleted"), description: t("User berhasil dihapus."), status: "success", duration: 3000, isClosable: true });
        await loadUsers();
      } else {
        toast({ title: t("Error"), description: result.message || t("Failed to delete user"), status: "error", duration: 3000, isClosable: true });
      }
    } catch {
      toast({ title: t("Error"), description: t("Failed to delete user"), status: "error", duration: 3000, isClosable: true });
    } finally {
      setSaving(false);
      setDeleteOpen(false);
    }
  };

  const confirmToggle = async () => {
    if (!selectedUser) return;
    try {
      setSaving(true);
      const isActive = selectedUser.status === "Active";
      const result = isActive ? await deactivateUser(selectedUser.id) : await activateUser(selectedUser.id);
      if (result.success) {
        toast({ title: isActive ? t("User Deactivated") : t("User Activated"), description: t(`User berhasil ${isActive ? "dinonaktifkan" : "diaktifkan"}.`), status: "success", duration: 3000, isClosable: true });
        await loadUsers();
      } else {
        toast({ title: t("Error"), description: result.message || t("Failed to update status"), status: "error", duration: 3000, isClosable: true });
      }
    } catch {
      toast({ title: t("Error"), description: t("Failed to update user status"), status: "error", duration: 3000, isClosable: true });
    } finally {
      setSaving(false);
      setToggleOpen(false);
    }
  };

  const hasFilters = filterNama || filterStatus;

  const filteredUsers = users.filter((u) => {
    const search = filterNama.toLowerCase().trim();
    const matchSearch = !search || u.nama.toLowerCase().includes(search) || u.email.toLowerCase().includes(search);
    const matchStatus = !filterStatus || u.status === filterStatus;
    return matchSearch && matchStatus;
  });

  return (
    <div className="lms-page lms-anim-fade">
      {/* Header */}
      <div className="lms-page-header">
        <div className="lms-page-header-text">
          <div className="lms-breadcrumb">
            <span>Apps</span><ChevronRightIcon /><span>Admin</span><ChevronRightIcon />
            <span className="lms-breadcrumb-current">{t("User Management")}</span>
          </div>
          <div className="t-display">{t("User Management")}</div>
          <div className="t-small">{t("Kelola pengguna platform, role akses, dan status akun.")}</div>
        </div>
        <button className="lms-btn lms-btn-primary" onClick={() => setCreateOpen(true)}>
          <PlusIcon /> {t("Create User")}
        </button>
      </div>

      <div className="lms-card">
        {/* Filter bar */}
        <div className="lms-card-body" style={{ paddingBottom: 0 }}>
          <div className="lms-filter-bar">
            <div className="lms-input-wrap" style={{ flex: 1, maxWidth: 360 }}>
              <SearchIcon />
              <input
                className="lms-input"
                placeholder={t("Cari nama atau email user…")}
                value={filterNama}
                onChange={(e) => setFilterNama(e.target.value)}
              />
            </div>
            <select
              className="lms-select"
              style={{ width: 180 }}
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
            >
              <option value="">{t("Semua Status")}</option>
              <option value="Active">{t("Active")}</option>
              <option value="Non Active">{t("Non Active")}</option>
            </select>
            {hasFilters && (
              <button
                className="lms-btn lms-btn-ghost lms-btn-sm"
                onClick={() => { setFilterNama(""); setFilterStatus(""); }}
              >
                <XIcon /> {t("Clear")}
              </button>
            )}
          </div>
        </div>

        {/* Table */}
        <div className="lms-table-wrap">
          <table className="lms-table">
            <thead>
              <tr>
                <th style={{ width: 40 }}>{t("No")}</th>
                <th>{t("Name")}</th>
                <th>{t("Email")}</th>
                <th>{t("Position")}</th>
                <th>{t("Phone")}</th>
                <th>{t("Status")}</th>
                <th>{t("Created")}</th>
                <th style={{ width: 52 }}></th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={8} style={{ textAlign: "center", padding: 48 }}>
                  <div className="lms-spinner" style={{ margin: "0 auto" }} />
                </td></tr>
              ) : filteredUsers.length === 0 ? (
                <tr><td colSpan={8}>
                  <div className="lms-empty">
                    <div className="lms-empty-icon"><SearchIcon /></div>
                    <div className="t-h3">{t("Tidak ada user ditemukan")}</div>
                    <div className="t-small">{t("Coba ubah filter atau kata kunci pencarian.")}</div>
                  </div>
                </td></tr>
              ) : filteredUsers.map((u, i) => (
                <tr key={u.id}>
                  <td className="lms-text-muted">{i + 1}</td>
                  <td>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <Avatar name={u.nama} />
                      <span className="td-strong">{u.nama}</span>
                    </div>
                  </td>
                  <td>{u.email}</td>
                  <td style={{ fontSize: 13, color: u.position ? "var(--text-base)" : "var(--text-muted)" }}>{u.position || "—"}</td>
                  <td style={{ fontSize: 13, color: "var(--text-muted)" }}>{u.phone || "—"}</td>
                  <td>
                    <Badge variant={u.status === "Active" ? "success" : "neutral"}>
                      {u.status === "Active" ? t("Active") : t("Inactive")}
                    </Badge>
                  </td>
                  <td className="lms-text-muted" style={{ fontSize: 13 }}>
                    {u.tanggalDibuat ? new Date(u.tanggalDibuat).toLocaleDateString("id-ID") : "-"}
                  </td>
                  <td>
                    <UserRowMenu
                      user={u}
                      onEdit={(u) => { setEditUserId(u.id); setEditOpen(true); }}
                      onToggle={(u) => { setSelectedUser(u); setToggleOpen(true); }}
                      onDelete={(u) => { setSelectedUser(u); setDeleteOpen(true); }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div className="lms-pagination">
          <span className="lms-pagination-info">
            Showing <strong>{filteredUsers.length}</strong> of <strong>{users.length}</strong> users
          </span>
        </div>
      </div>

      {/* Create User Modal */}
      <CreateUserModal
        open={createOpen}
        onClose={() => setCreateOpen(false)}
        onCreated={() => { setCreateOpen(false); loadUsers(); }}
        toast={toast}
      />

      {/* Edit User Modal */}
      <EditUserModal
        open={editOpen}
        userId={editUserId}
        onClose={() => setEditOpen(false)}
        onUpdated={() => { setEditOpen(false); loadUsers(); }}
        toast={toast}
      />

      {/* Delete dialog */}
      <ConfirmDialog
        open={deleteOpen}
        title={t("Delete User")}
        message={<>Apakah Anda yakin ingin menghapus user <strong>"{selectedUser?.nama}"</strong>? Tindakan ini tidak dapat dibatalkan.</>}
        confirmLabel={t("Delete")}
        confirmVariant="danger"
        loading={saving}
        onConfirm={confirmDelete}
        onCancel={() => setDeleteOpen(false)}
      />

      {/* Toggle status dialog */}
      <ConfirmDialog
        open={toggleOpen}
        title={selectedUser?.status === "Active" ? t("Deactivate User") : t("Activate User")}
        message={
          selectedUser?.status === "Active"
            ? <> Apakah Anda yakin ingin menonaktifkan user <strong>"{selectedUser?.nama}"</strong>?</>
            : <> Apakah Anda yakin ingin mengaktifkan kembali user <strong>"{selectedUser?.nama}"</strong>?</>
        }
        confirmLabel={selectedUser?.status === "Active" ? t("Deactivate") : t("Activate")}
        confirmVariant={selectedUser?.status === "Active" ? "danger" : "primary"}
        loading={saving}
        onConfirm={confirmToggle}
        onCancel={() => setToggleOpen(false)}
      />
    </div>
  );
}

export default UserManagement;
